<template lang="pug">
.layout
  y-dialog(v-if="showModal" v-model="showModal" scrollable max-width="600px" persistent :fullscreen="$vuetify.breakpoint.xsOnly")
    v-card
      v-card-title.px-4
        v-btn(icon small @click='showModal = false')
          v-icon(size="22" color="primary") mdi-close
        div.h6.basic800--text.ml-4 {{ $t('filters') }}
        v-spacer
        v-btn(color='white', text @click="resetFilter")
          .button-Aa-small.primary400--text {{ $t('reset') }}
        v-btn.mr-2(color='textColorAccent' depressed height=32 @click="applyFilter" dark)
          .button-AA-small.basic100--text {{ $t('done') }}
      v-divider.basic300
      v-card-text.pa-0
        .sort
          sort-order.pa-6(:parentSortOrder.sync="sortOrder")
          v-divider.basic300

        .date(v-if="view !== 'calendar'")
          date-order.pa-6(:parentDateOrder.sync="dateOrder" :parentRangeOrder.sync="rangeOrder" :orderType="orderType")
          v-divider.basic300
        
        .status(v-if="view !== 'kanban'")
          status-order.pa-6(:parentProcessingOrder.sync="processingOrder" :parentReadyOrder.sync="readyOrder")
          v-divider.basic300

        .shipping
          shipping-order.pa-6(:parentShippingOrder.sync="shippingOrder" :company="company")
          v-divider.basic300
        
        .payment
          payment-order.pa-6(:parentPaymentOrder.sync="paymentOrder")
          v-divider.basic300

        .source
          source-order.pa-6.mb-16(:parentSourceOrder.sync="sourceOrder")
          v-divider.basic300

</template>

<script>
import { mapGetters } from 'vuex'
import SortOrder from '@/components/ordermgmt/filters/SortOrder.vue'
import DateOrder from '@/components/ordermgmt/filters/DateOrder.vue'
import StatusOrder from '@/components/ordermgmt/filters/StatusOrder.vue'
import ShippingOrder from '@/components/ordermgmt/filters/ShippingOrder.vue'
import PaymentOrder from '@/components/ordermgmt/filters/PaymentOrder.vue'
import SourceOrder from '@/components/ordermgmt/filters/SourceOrder.vue'

export default {
  name: 'OrderFilter',
  components: { SortOrder, DateOrder, StatusOrder, ShippingOrder, PaymentOrder, SourceOrder },
  props: ['open', 'company', 'orderType'],
  data: () => ({
    sortOrder: 'newest',
    dateOrder: null,
    rangeOrder: {
      name: 'All',
      value: null,
      date: null
    },
    processingOrder: [],
    readyOrder: [],
    shippingOrder: null,
    paymentOrder: [],
    sourceOrder: []
  }),
  computed: {
    ...mapGetters({
      view: 'orders/getOrderView',
      filters: 'orders/getFilters'
    }),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  watch: {
  },
  created () {
    this.checkFilter()
  },
  methods: {
    checkFilter () {
      this.sortOrder = this.filters.sort || 'newest',
      this.dateOrder = this.filters.date || null,
      this.rangeOrder = this.filters.range || { name: 'All', value: null, date: null },
      this.processingOrder = this.filters.processing || [],
      this.readyOrder = this.filters.ready || [],
      this.shippingOrder = this.filters.shipping || null,
      this.paymentOrder = this.filters.payment || [],
      this.sourceOrder = this.filters.source || []
    },
    resetFilter () {
      this.sortOrder = 'newest'
      this.dateOrder = null
      this.rangeOrder = {
        name: 'All',
        value: null,
        date: null
      },
      this.processingOrder = []
      this.readyOrder = []
      this.shippingOrder = null
      this.paymentOrder = []
      this.sourceOrder = []
    },
    applyFilter () {
      let params = {
        sort: this.sortOrder,
        date: this.dateOrder,
        range: this.rangeOrder,
        processing: this.processingOrder.length > 0 ? this.processingOrder : null,
        ready: this.readyOrder.length > 0 ? this.readyOrder : null,
        shipping: this.shippingOrder,
        payment: this.paymentOrder.length > 0 ? this.paymentOrder : null,
        source: this.sourceOrder.length > 0 ? this.sourceOrder : null,
      }
      this.$store.commit('orders/setFilters', params)
      this.showModal = false
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
div >>> .v-list-item--active{
  background-color: var(--v-info500) !important;
  color:white;
}
</style>
